/**
 * Header section: StickyHeader + scroll, expand-down, and UI behavior
 */
(function() {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      var observer = new IntersectionObserver(function(entries, obs) {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      }.bind(this));

      observer.observe(this.header);
    }

    onScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.preventReveal) {
        this.preventReveal = false;
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.header.classList.contains('menu-open')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      var delta = scrollTop - this.currentScrollTop;
      if (Math.abs(delta) < 2) {
        this.currentScrollTop = scrollTop;
        return;
      }

      var scrollingDown = delta > 0;
      var topThreshold = 48;
      var hideAfter = Math.max((this.headerBounds && this.headerBounds.bottom) ? this.headerBounds.bottom : 0, 72);

      if (scrollTop <= topThreshold) {
        requestAnimationFrame(this.reset.bind(this));
      } else if (scrollingDown && scrollTop > hideAfter) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (!scrollingDown) {
        requestAnimationFrame(this.reveal.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.hideSubHeader();
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    stick() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      this.hideSubHeader();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.showSubHeader();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(function(disclosure) { return disclosure.close(); });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    hideSubHeader() {
      var subHeader = document.querySelector('.sub-header');
      if (subHeader) {
        subHeader.classList.add('hidden');
      }
    }

    showSubHeader() {
      var subHeader = document.querySelector('.sub-header');
      if (subHeader) {
        subHeader.classList.remove('hidden');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    var header = document.querySelector('.header-wrapper');
    var lastScrollTop = 0;
    var isScrollingDown = false;
    var hideDimTimer;

    /* ── Dim overlay ── */
    function updateHeaderHeight() {
      var headerEl = document.querySelector('.header-wrapper');
      if (!headerEl) return;
      /* Use the full bounding bottom of header-wrapper (includes expand panel) */
      var bottom = headerEl.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-total-height', bottom + 'px');
      var headerBar = headerEl.querySelector('.header');
      if (headerBar) {
        document.documentElement.style.setProperty('--header-bar-height', headerBar.offsetHeight + 'px');
      }
    }

    function updateHeaderHeightWithExpand() {
      var headerEl = document.querySelector('.header-wrapper');
      if (!headerEl) return;
      var expandEl = document.getElementById('header-expand');
      var bottom = headerEl.getBoundingClientRect().bottom;
      if (expandEl && expandEl.offsetHeight > 0) {
        bottom = expandEl.getBoundingClientRect().bottom;
      }
      document.documentElement.style.setProperty('--header-total-height', bottom + 'px');
    }

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    function showDim() {
      if (hideDimTimer) {
        clearTimeout(hideDimTimer);
        hideDimTimer = null;
      }
      /* Small delay so expand panel has rendered and we can measure it */
      setTimeout(updateHeaderHeightWithExpand, 50);
      document.body.classList.add('header-dropdown-open');
    }
    function hideDim() {
      if (hideDimTimer) {
        clearTimeout(hideDimTimer);
        hideDimTimer = null;
      }
      document.body.classList.remove('header-dropdown-open');
      updateHeaderHeight();
    }
    function scheduleHideDim(delayMs) {
      if (hideDimTimer) clearTimeout(hideDimTimer);
      hideDimTimer = setTimeout(function() {
        hideDimTimer = null;
        hideDim();
      }, delayMs);
    }

    /* Click outside header closes dropdowns and removes dim */
    document.addEventListener('click', function (e) {
      if (!document.body.classList.contains('header-dropdown-open')) return;
      if (!e.target.closest('.header-wrapper')) {
        document.querySelectorAll('.header-wrapper details[open]').forEach(function (d) {
          d._dropdownPinned = false;
          d._dropdownClosedByClick = false;
          d.removeAttribute('open');
        });
        scheduleHideDim(340);
      }
    });
    /* ── End dim overlay ── */

    function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      if (window.innerWidth > 1023) {
        if (scrollTop > lastScrollTop && scrollTop > 200) {
          if (!isScrollingDown) {
            header.classList.add('shrink');
            isScrollingDown = true;
          }
        } else {
          if (isScrollingDown) {
            header.classList.remove('shrink');
            isScrollingDown = false;
          }
        }
      }

      lastScrollTop = scrollTop;
    }

    var scrollTimeout;
    function throttledScroll() {
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(function() {
          handleScroll();
          scrollTimeout = null;
        }, 16);
      }
    }

    window.addEventListener('scroll', throttledScroll, { passive: true });
    handleScroll();

    // Desktop dropdowns: hover to open/close, click to toggle
    var DROPDOWN_OPEN_DELAY = 90;
    var DROPDOWN_CLOSE_DELAY = 300;
    var DROPDOWN_CLOSE_ANIM_MS = 340;
    var dropdownMenus = document.querySelectorAll('.header__inline-menu header-menu details');

    function isDesktopNav() {
      return window.innerWidth >= 1024;
    }

    dropdownMenus.forEach(function(details) {
      var summary = details.querySelector('summary');
      var submenu = details.querySelector('.header__submenu, .mega-menu__content');
      var closeTimeout;
      var openTimeout;

      function isPointerOverThis() {
        var expand = document.getElementById('header-expand');
        var expandChild = expand && expand.firstElementChild;
        var isOverSummary = summary && summary.matches(':hover');
        var isOverSubmenu = submenu && submenu.matches(':hover');
        var isOverExpand = expand && expand.matches(':hover') && expandChild &&
          expandChild.getAttribute('data-parent-details-id') === details.id;
        return isOverSummary || isOverSubmenu || isOverExpand;
      }

      function openDropdown() {
        if (openTimeout) {
          clearTimeout(openTimeout);
          openTimeout = null;
        }
        clearTimeout(closeTimeout);
        details._dropdownClosedByClick = false;
        dropdownMenus.forEach(function(other) {
          if (other !== details) {
            other._dropdownPinned = false;
            other._dropdownClosedByClick = false;
          }
        });
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        showDim();
      }

      function closeDropdown() {
        if (openTimeout) {
          clearTimeout(openTimeout);
          openTimeout = null;
        }
        clearTimeout(closeTimeout);
        details._dropdownPinned = false;
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        if (document.querySelectorAll('.header-wrapper details[open]').length === 0) {
          scheduleHideDim(DROPDOWN_CLOSE_ANIM_MS);
        }
      }

      function scheduleCloseDropdown() {
        if (details._dropdownPinned) return;
        if (openTimeout) {
          clearTimeout(openTimeout);
          openTimeout = null;
        }
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(function() {
          if (details._dropdownPinned) return;
          if (!isPointerOverThis()) {
            closeDropdown();
          }
        }, DROPDOWN_CLOSE_DELAY);
      }

      function handleMouseEnter() {
        if (!isDesktopNav()) return;
        if (details._dropdownClosedByClick) return;
        if (openTimeout) clearTimeout(openTimeout);
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(function() {
          openTimeout = null;
          if (details._dropdownClosedByClick) return;
          openDropdown();
        }, DROPDOWN_OPEN_DELAY);
      }

      function handleMouseLeave() {
        if (!isDesktopNav()) return;
        details._dropdownClosedByClick = false;
        scheduleCloseDropdown();
      }

      if (summary) {
        summary.addEventListener('click', function(e) {
          if (!isDesktopNav()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          if (details.hasAttribute('open')) {
            details._dropdownClosedByClick = true;
            closeDropdown();
          } else {
            details._dropdownPinned = true;
            openDropdown();
          }
        }, true);
        summary.addEventListener('mouseenter', handleMouseEnter);
        summary.addEventListener('mouseleave', handleMouseLeave);
      }

      if (submenu) {
        submenu.addEventListener('mouseenter', handleMouseEnter);
        submenu.addEventListener('mouseleave', handleMouseLeave);
      }
    });

    var searchToggle = document.querySelector('.header__icon--search');
    if (searchToggle) {
      searchToggle.addEventListener('click', function() {
        setTimeout(function() {
          var searchInput = document.getElementById('Search-In-Modal');
          if (searchInput) searchInput.focus();
        }, 300);
      });
    }

    (function expandDown() {
      var headerWrapper = document.querySelector('.header-wrapper');
      var headerExpand = document.getElementById('header-expand');
      if (!headerWrapper || !headerExpand) return;

      function isDesktop() { return window.innerWidth >= 1024; }

      function moveContentBack(closeDetails) {
        if (headerExpand._closeTimer) {
          clearTimeout(headerExpand._closeTimer);
          headerExpand._closeTimer = null;
        }
        headerExpand.classList.remove('is-closing');
        var content = headerExpand.firstElementChild;
        if (!content) return;
        var detailsId = content.getAttribute('data-parent-details-id');
        if (!detailsId) return;
        var details = document.getElementById(detailsId);
        if (details) {
          var summary = details.querySelector('summary');
          if (summary && summary.nextElementSibling === null) details.insertBefore(content, summary.nextSibling);
          else if (summary) details.appendChild(content);
          if (closeDetails) {
            details.removeAttribute('open');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
        }
        headerExpand.setAttribute('aria-hidden', 'true');
      }

      function closeExpandWithTransition(details) {
        var activeContent = headerExpand.firstElementChild;
        if (!activeContent || activeContent.getAttribute('data-parent-details-id') !== details.id) return;
        if (headerExpand._closeTimer) clearTimeout(headerExpand._closeTimer);
        headerExpand.classList.add('is-closing');
        headerExpand.setAttribute('aria-hidden', 'true');
        headerExpand._closeTimer = setTimeout(function() {
          headerExpand._closeTimer = null;
          moveContentBack(false);
        }, DROPDOWN_CLOSE_ANIM_MS);
      }

      function setupExpandDown() {
        var menus = headerWrapper.querySelectorAll('.header__inline-menu details');
        menus.forEach(function(details) {
          var content = details.querySelector('summary') && details.querySelector('summary').nextElementSibling;
          if (!content) return;
          if (details._expandDownSetup) return;
          details._expandDownSetup = true;

          details.addEventListener('toggle', function() {
            if (!isDesktop()) return;
            if (details.open) {
              if (headerExpand._closeTimer) {
                clearTimeout(headerExpand._closeTimer);
                headerExpand._closeTimer = null;
              }
              headerExpand.classList.remove('is-closing');
              var existing = headerExpand.firstElementChild;
              if (existing) {
                var prevId = existing.getAttribute('data-parent-details-id');
                var prevDetails = prevId ? document.getElementById(prevId) : null;
                if (prevDetails) {
                  prevDetails.removeAttribute('open');
                  prevDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
                  if (prevDetails.querySelector('summary')) prevDetails.querySelector('summary').after(existing);
                }
                existing.removeAttribute('data-parent-details-id');
              }
              content.setAttribute('data-parent-details-id', details.id);
              headerExpand.appendChild(content);
              headerExpand.setAttribute('aria-hidden', 'false');
            } else {
              closeExpandWithTransition(details);
            }
          });
        });
      }

      setupExpandDown();
      window.addEventListener('resize', function() {
        if (!isDesktop() && headerExpand.firstElementChild) moveContentBack(true);
      });
      document.addEventListener('shopify:section:load', function() { setupExpandDown(); });
    })();

    if ('ontouchstart' in window) {
      document.body.classList.add('touch-device');
      var touchElements = document.querySelectorAll('.header__icon, .header__menu-item');
      touchElements.forEach(function(el) {
        el.addEventListener('touchstart', function() {
          this.style.transform = 'scale(0.95)';
        }, { passive: true });
        el.addEventListener('touchend', function() {
          var el_ = this;
          setTimeout(function() { el_.style.transform = ''; }, 150);
        }, { passive: true });
      });
    }
  });
})();
